module.exports = __webpack_public_path__ + "static/media/web04_ch02.20dad1ef.png";